<template>
  <div class="flex flex-col min-h-screen">
    <div class="fixed z-10 w-full glass-nav">
      <MyHeader />
    </div>
    <main class="container pb-5 m-auto mt-16">
      <slot />
    </main>
    <div>
      <MyFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
// import UAParser from 'ua-parser-js';

// const isMobile = ref(false);

// const parser = new UAParser();
// const router = useRouter();
// const result = parser.getResult();
// if (result.device.type === 'mobile') {
//   // 是移动端，跳转到移动端路由
//   isMobile.value = true
// } else {
//   // 是桌面端，跳转到桌面端路由
//   isMobile.value = false
// }
import { userLogin } from '~/stores/userLogin'
import { tokenName } from '~/stores/tokenName'

onMounted(() => {
  //检测本地是否有缓存 token 如果有则设置登录状态如果没有则重新登录
  const token = useCookie(tokenName)
  const loginStore = userLogin()
  if (token.value != null) {
    loginStore.isLogin = true
  } else {
    //获取用户信息

    loginStore.isLogin = false
  }
})
</script>
